// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".self-sub-container{position:relative;transition:background-color 0.5s ease;min-height:100vh}.content-container{position:relative;border-radius:20px;padding:20px 0;box-sizing:border-box;overflow-x:hidden;font-size:14px;width:1024px;max-width:90%;margin:auto}.content-container li{margin:5px 0}.content-container .segment-item-label{font-weight:bold}.content-container a{color:black !important}.content-container a.link-white{color:white !important}\n", ""]);
// Exports
module.exports = exports;
